ObjectUtils.define('UIController', {

  enableDebug: 0,
  _listeners: {},
  _numListeners: 0,

  define: function define(name, definition) {
    ObjectUtils.define(name, this, definition);
  },

  didLoadId: function didLoadId(id, data) {
    var container = DOM.findById(id);

    // Sometimes content gets replaced maybe?
    // https://rollbar.com/Buxfer/Frontend/items/10990/occurrences/200802191396/
    if (!container) {
      return;
    }

    this.didLoad(container, data);
    this._setupNotificationHandlers(container);
  },

  didUnload: function didUnload(container) {
    if (!this.declareNotificationHandlers) {
      return;
    }

    var listenerId = DOM.getAttribute(container, 'listenerId');
    if (!listenerId) {
      return;
    }
    
    ArrayUtils.each(this._listeners[listenerId], FunctionUtils.bind(this, function(index, tokenId) {
      this.enableDebug && Logger.log(this, 'Removing notification handler', {
        tokenId: tokenId,
        listenerId: listenerId,
      });
      NotificationManager.remove(tokenId);
    }));
    delete this._listeners[listenerId];
  },

  _setupNotificationHandlers: function _setupNotificationHandlers(container) {
    if (!this.declareNotificationHandlers) {
      return;
    }

    var listenerId = 'listener-'+this._numListeners;
    ++this._numListeners;
    DOM.setAttribute(container, 'listenerId', listenerId);
    this._listeners[listenerId] = [];

    ArrayUtils.each(this.declareNotificationHandlers(), FunctionUtils.bind(this, function(index, eventConfig) {
      var eventHandler = FunctionUtils.bind(this, eventConfig.handler, container);
      var tokenId = NotificationManager.subscribe(eventConfig.event, eventHandler);

      this._listeners[listenerId].push(tokenId);
      this.enableDebug && Logger.log(this, 'Adding notification handler', {
        event: eventConfig.event,
        tokenId: tokenId,
        listenerId: listenerId,
      });
    }));
  },

  dataDidInvalidate: function dataDidInvalidate(data) {
    var target = data.target;

    if (target && target !== '__page' && target !== '__overlay') {
      UIComponentController.reloadAll({}, {
        source: target
      });
    }
  },

  get: function get(node) {
    return Assert.TRUTHY(this.maybeGet(node), 'Expected valid controller');
  },

  maybeGet: function maybeGet(node) {
    var controllerName = DOM.getAttribute(node, 'controller');
    if (!controllerName) {
      return;
    }
    var controller = ObjectUtils.maybeResolveByName(controllerName);
    if (!controller) {
      ErrorManager.warn('Failed to resolve controller ['+controllerName+']');
    }
    return controller;
  },

  maybeFindAsyncParent: function maybeFindAsyncParent(element) {
    return DOM.maybeFindParent(element, function(node) {
      return DOM.getAttribute(node, 'component-src');
    });
  },

  maybeReloadAsyncParentWithUrl: function maybeReloadAsyncParentWithUrl(element, reloadUrl) {
    var asyncParent = this.maybeFindAsyncParent(element);

    if (!asyncParent) {
      return EventDelegater.FORWARD;
    }

    // It's questionable if the URL should be updated here. Only part of the
    // page is updated. A full refresh can cause other components to be updated,
    // E.g.: Account balance chart period picker => Full refresh has side-effects
    // However, transaction list filters need to be reflected in the page so referrer redirects work.
    // https://buxfer.zendesk.com/agent/tickets/103210
    if (DOM.getAttribute(element, 'shouldUpdatePageUrl') === 'true') {
      Page.mergeAndSetUrl(reloadUrl);
    }

    UIComponentController.reload(asyncParent, {
      href: reloadUrl
    });

    return EventDelegater.STOP;
  },

});
